

module.exports = __webpack_require__.stylable.create(
    "Loader3513780140",
    {"classes":{"root":"Loader3513780140__root","statusIndicator":"Loader3513780140__statusIndicator","arcsContainer":"Loader3513780140__arcsContainer","darkArc":"Loader3513780140__darkArc","lightArc":"Loader3513780140__lightArc","text":"Loader3513780140__text"},"vars":{},"stVars":{},"keyframes":{"rotation":"Loader3513780140__rotation","staggered-rotation":"Loader3513780140__staggered-rotation"}},
    "",
    2,
    "Loader3513780140",
    null
);
